module.exports = __webpack_public_path__ + "img/tcHelp.ca161b00.png";